import { Navigate, Outlet } from "react-router-dom";

export default function AdminRoute() {
    const token = localStorage.getItem("token");
    const userType = localStorage.getItem("userType");

    if (!token) {
        return <Navigate to="/" replace />;
    }

    if (userType !== "Admin") {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}